import { AppPhase, DealingSubPhase, GameType } from '../../models/communication/app-enums.model';
import { AppEventType } from '../../models/communication/app-events.model';
import { BaccaratCardPosition, BaccaratOutcome } from '../main-games/baccaraat/baccarat.model';

export const configuration = {
    gameType: GameType.OpenBaccarat,
    decisionTimeInSeconds: 4
};

export const demoEvents = [
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.DealingCards,
            subPhase: DealingSubPhase.FaceDown
        }
    },

    {
        name: AppEventType.CardDealt,
        data: {
            card: 0,
            cardPosition: BaccaratCardPosition.PlayerFirstCard,
            bankerHandValue: 0,
            playerHandValue: 0,
            nextCardPosition: BaccaratCardPosition.BankerFirstCard
        }
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 0,
            cardPosition: BaccaratCardPosition.BankerFirstCard,
            playerHandValue: 0,
            bankerHandValue: 3,
            nextCardPosition: BaccaratCardPosition.PlayerSecondCard
        }
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 0,
            cardPosition: BaccaratCardPosition.PlayerSecondCard,
            playerHandValue: 7,
            bankerHandValue: 3,
            nextCardPosition: BaccaratCardPosition.BankerSecondCard
        }
    },
    [
        {
            name: AppEventType.CardDealt,
            data: {
                card: 0,
                cardPosition: BaccaratCardPosition.BankerSecondCard,
                playerHandValue: 7,
                bankerHandValue: 3
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.DealingCards,
                subPhase: DealingSubPhase.SideSelectionAnimation
            }
        }
    ],

    [
        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.DealingCards,
                subPhase: DealingSubPhase.LeftSide
            }
        },

        {
            name: AppEventType.CardDealt,
            data: {
                card: 213,
                cardPosition: BaccaratCardPosition.BankerFirstCard,
                bankerHandValue: 0,
                playerHandValue: 0
            }
        },

        {
            name: AppEventType.CardDealt,
            data: {
                card: 407,
                cardPosition: BaccaratCardPosition.BankerSecondCard,
                playerHandValue: 7,
                bankerHandValue: 3
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.Decision
            }
        }
    ],

    [
        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.BetsClosed
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.DealingCards,
                subPhase: DealingSubPhase.Dealing
            }
        },

        {
            name: AppEventType.CardDealt,
            data: {
                card: 303,
                cardPosition: BaccaratCardPosition.PlayerFirstCard,
                playerHandValue: 0,
                bankerHandValue: 3
            }
        },
        {
            name: AppEventType.CardDealt,
            data: {
                card: 110,
                cardPosition: BaccaratCardPosition.PlayerSecondCard,
                playerHandValue: 7,
                bankerHandValue: 3,
                nextCardPosition: BaccaratCardPosition.PlayerThirdCard
            }
        }
    ],

    {
        name: AppEventType.CardDealt,
        data: {
            card: 201,
            cardPosition: BaccaratCardPosition.PlayerThirdCard,
            playerHandValue: 8,
            bankerHandValue: 3,
            nextCardPosition: BaccaratCardPosition.BankerThirdCard
        }
    },

    [
        {
            name: AppEventType.CardDealt,
            data: {
                card: 304,
                cardPosition: BaccaratCardPosition.BankerThirdCard,
                playerHandValue: 8,
                bankerHandValue: 7,
                outcome: BaccaratOutcome.BankerWin
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.RoundEnd,
                outcome: BaccaratOutcome.BankerWin
            }
        }
    ]
];
